import { render, staticRenderFns } from "./RealtimeStatusForm.vue?vue&type=template&id=28482562"
import script from "./RealtimeStatusForm.vue?vue&type=script&lang=js"
export * from "./RealtimeStatusForm.vue?vue&type=script&lang=js"
import style0 from "./RealtimeStatusForm.vue?vue&type=style&index=0&id=28482562&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports